export enum ApprovalStatus {
  /** 待处理 */
  Pending = 'pending',
  /** 已处理 */
  Processed = 'processed'
}

export enum ApprovalMeetingStatus {
  /** 初始化 */
  Init = 0,
  /** 已通过 */
  Passed = 1,
  /** 不通过 */
  Fail = 2,
  /** 已过期 */
  Expired = 3,
  /** 已撤销 */
  Revoke = 4,
  /** 无需审批 */
  noNeed = 4
}

export enum NewApprovalMeetingStatus {
  /* 审批中 */
  AUDITING = 'AUDITING',
  /* 已同意 */
  AGREE = 'AUDIT_AGREE',
  /* 已拒绝 */
  REFUSE = 'AUDIT_REFUSE',
  /* 已过期 */
  EXPIRED = 'AUDIT_EXPIRED',
  /* 已撤销 */
  REVOKED = 'AUDIT_REVOKE'
}

export enum ApprovalType {
  /** 会议服务 */
  Meeting = 'MEETING_SERVICE',
  /** 会议室 */
  Room = 'ROOM'
}
